import { type Auth } from "firebase/auth";
import { LoanLinkApi, type RequestParams } from "./generatedApi";
import { getAuth } from "firebase/auth";

let auth: Auth;

async function securityWorker(): Promise<RequestParams> {
	const headers: HeadersInit = {};

	if (!auth) {
		auth = getAuth();
	}

	if (auth.currentUser) {
		const idToken = await auth.currentUser.getIdToken();
		headers.Authorization = `Bearer ${idToken}`;
	}

	return { headers };
}

const baseUrl = import.meta.env.VITE_API_BASE_URL;

export const api = new LoanLinkApi({
	baseApiParams: { secure: true },
	baseUrl,
	securityWorker,
});
